import React from 'react';
import { styled } from '@ff/ui';
import Icon from '@ff/ui/Icon';
import { P14 } from 'client/v3/typography';
import { NavLink, useLocation } from 'react-router-dom';

export default function EditDesign() {
  const { pathname, search } = useLocation();

  // remove last part, /us/design/2022/FF91/summary => /us/design/2022/FF91
  const basePath = pathname.slice(0, pathname.lastIndexOf('/'));

  return (
    <Container to={{ pathname: `${basePath}/options`, search: `${search}&CURRENT_OPTION=EXC` }} >
      <Icon name='ff-icon-keyboard_arrow_up' fontSize='24px' />
      <P14>Edit Design</P14>
    </Container>
  )
}

const Container = styled(NavLink)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '28px',
  marginBottom: '34px',
  textDecoration: 'none',
  width: 'fit-content',
  color: 'black',
  ':visited': {
    color: 'black'
  }
});
